export enum ApiAuthStrategy {
  Account = "ACCOUNT",
  GuestAccount = "GUEST_ACCOUNT",
}
